// extracted by mini-css-extract-plugin
module.exports = {"back-button":"ContactDetail_back-button__19tNI","identifier":"ContactDetail_identifier__1RY78","detail-sections":"ContactDetail_detail-sections__1pYDi"};